import {apiConfig} from '@stencil/hotels-config';
const {__MAPI__} = apiConfig;

export function getNewAutoSuggestUrl({
  search_query,
  exps,
  expKey,
  flavour = 'v3',
  isDayUse = false,
  isInCitySearch = false,
  locusId = '',
}) {
  const params: {
    language: string;
    region: string;
    q: string;
    z: boolean;
    brand: string;
    funnel?: string;
    exps?: string;
    exp?: number;
    t?: string;
    c?: string;
  } = {
    language: 'eng',
    region: 'in',
    q: search_query,
    z: false,
    brand: 'GI',
    exps,
    exp: expKey,
  };

  if (isDayUse) {
    params.funnel = 'dayuse';
  }

  if (isInCitySearch) {
    params.c = locusId;
    params.t = 'hotel';
  }

  let paramsStringified;
  var queryString = Object.keys(params)
    .map(key => key + '=' + params[key])
    .join('&');
  paramsStringified = `?${queryString}`;

  let url = `${__MAPI__}/autosuggest/v5/search${paramsStringified}`;
  return url;
}
